import React, { memo } from 'react';

import { PAGE_TYPES } from '../constants';
import ContentLandingPage from '../pages/ContentLandingPage/component';
import { CurrencyContext } from './context';

const PAGES = {
    [PAGE_TYPES.CONTENT_LANDING_PAGE]: ContentLandingPage,
    [PAGE_TYPES.SELLER_JOB_PAGE]: ContentLandingPage
};

const App = (props) => {
    const { pageInfo } = props;
    const Component = PAGES[pageInfo?.pageType] || PAGES[PAGE_TYPES.CONTENT_LANDING_PAGE];

    return (
        <CurrencyContext.Provider value={props.context?.currency}>
            <Component {...props}/>
        </CurrencyContext.Provider>
    );

};

export default memo(App);
